<template>
    <div>
        <h1>Contacto</h1>
        <hr>
        <div class="card">
            <div class="card-body">
                <p>Actualmente, de los servicios ofrecidos, para el desarrollo web/app o acesorias, se establece una tarifa por hora, hasta culminar el proyecto si es el caso. Se trabaja con repositorios GitHub para tener transparencia con el codigo elaborado o si lo deseas un archivo comprimido, de acuerdo a tus necesidades.</p>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <p><b>Frameworks:</b> codeigniter, laravel, boostrap, <b>Lenguajes:</b> php, java, javascript <b>App: </b>nativas con android studio <b>Otros: </b> vue js, livewire, docker(basico), gitHub</p>
            </div>
        </div>
        
        <div class="card mt-4">
            <div class="card-body">
                <div class="col-12">
                    <form @submit.prevent="sendEmail()">
                        <div class="row g-3">
                            <div class="col-12 mb-3"><a type="button" href="https://wa.me/573177858446?text=Hola,%20te%20escribo%20por%20" target="_blank" class="btn btn-outline-success"><i class="fa fa-mobile"></i> WhatsApp</a></div>
                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <label class="form-label">Nombres/Apellidos</label>
                                <input type="text" class="form-control" placeholder="Juan Lopez" required="" v-model="datos.name" @keyup="validateName()">
                                <span class="badge bg-danger" v-if="errorName !=''">{{ errorName }}</span>
                            </div>

                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <label class="form-label">Correo</label>
                                <input type="email" class="form-control" placeholder="correo@correo.co" required="" v-model="datos.email" @keyup="validateName()">
                                <span class="badge bg-danger" v-if="errorEmail !=''">{{ errorEmail }}</span>
                            </div>

                            <div class="col-md-12 col-lg-12 col-xl-12">
                                <label class="form-label">Descripcion</label>
                                <textarea class="form-control" placeholder="Descripcion sobre lo que necesitas o buscas" required="" v-model="datos.description" @keyup="validateName()"></textarea>
                                <span class="badge bg-danger" v-if="errorDescription !=''">{{ errorDescription }}</span>
                            </div>
                        </div>

                        <hr class="my-4">

                        <div class="col-12 text-center"><button class="btn btn-primary" v-if="btnSave" type="submit"><i class="fa fa-check"></i> Enviar</button></div>
                    </form>
                    <Loading v-if="showLoading"/>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import Loading from '../components/Loading.vue'

    export default {
        components:{
            Loading
        },
        data: () => ({
            errors: [],
            datos:{
                name: "",
                email: "",
                description: ""
            },
            errorName: "",
            errorEmail: "",
            errorDescription: "",
            url: "https://sistemas-978b0-default-rtdb.firebaseio.com/emails/",
            showLoading: false,
            btnSave: true
        }),
        mounted(){
            this.showLoading = false
            this.btnSave = true
        },
        computed:{
        },
        methods:{
            validateName(){
                if(this.datos.name.length == 0){
                    this.errors.push("Debes ingresar un nombre/apellido");
                    this.errorName = "Debes ingresar un nombre/apellido"
                }else{
                    this.errors = [];
                    this.errorName = ""
                }
                if(this.datos.email.length == 0 && this.datos.email.includes('@') && this.datos.email.includes('.')){
                    this.errors.push("Debes ingresar un correo valido");
                    this.errorEmail = "Debes ingresar un correo valido"
                }else{
                    this.errors = [];
                    this.errorEmail = ""
                }
                if(this.datos.description.length == 0){
                    this.errors.push("Debes ingresar una descripcion");
                    this.errorDescription = "Debes ingresar una descripcion"
                }else{
                    this.errors = [];
                    this.errorDescription = ""
                }
            },
            sendEmail(){
                this.validateName()
                if(this.errors.length == 0){
                    this.showLoading = true
                    this.btnSave = false
                    this.send();
                }else{
                    this.message('error', 'Debes completar los campos!')
                }
            },
            async send(){
                const user = JSON.parse(localStorage.getItem("user"));
                const res = await fetch(this.url + ".json",{
                    method: "POST",
                    body: JSON.stringify(this.datos)
                });
                this.reset()
                this.showLoading = false
                this.btnSave = true
                this.message('success', 'Enviado con exito!')
            },
            reset(){
                this.datos.name = "",
                this.datos.email = "",
                this.datos.description = ""
            },
            message(type, msg){
                Swal.fire({
                    position: 'top-end',
                    icon: type,
                    title: msg,
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
    }
</script>